import Tabs from './tabs';
import TabsRound from './tabs-round';

export * from './tabs';

export {TabsRound};
export default Tabs;
